export const UNIT_TIME_SELECTABLES = [
  {
    label: 'Diario',
    value: 'diario',
  },
  {
    label: 'Semanal',
    value: 'semanal',
  },
  {
    label: 'Mensual',
    value: 'mensual',
  },
  {
    label: 'Trimestral',
    value: 'trimestral',
  },
  {
    label: 'Cuatrimestral',
    value: 'cuatrimestre',
  },
  {
    label: 'Semestral',
    value: 'semestral',
  },
  {
    label: 'Anual',
    value: 'anual',
  },
];

export const PAYMENT_STATUS_COLOR = [
  { text: 'paid', color: 'success' },
  { text: 'pending', color: 'orange' },
  { text: 'failed', color: 'danger' },
  { text: 'refunded', color: 'blue' },
  { text: 'cancelled', color: 'rose' },
  { text: 'approved', color: 'success' },
  { text: 'rejected', color: 'danger' },
];
